/**
 * Types and constants for the Review Comments view.
 * Requirements: 2.1, 2.2
 */

// ── SectionCategory (mirrors Prisma enum) ─────────────────────

export type SectionCategory =
  | 'GeneralArticles'
  | 'Advertisers'
  | 'TileSpacePurchasers'
  | 'SponsorAds'
  | 'Templates'
  | 'WelcomeMessage'
  | 'EventSchedule'
  | 'MemberProfiles'
  | 'MemorialTributes'
  | 'PhotoGallery'
  | 'CommitteeReports';

// ── User-friendly labels for each SectionCategory ─────────────

export const SECTION_CATEGORY_LABELS: Record<SectionCategory, string> = {
  GeneralArticles: 'Articles',
  Advertisers: 'Ad Space',
  TileSpacePurchasers: 'Tiles',
  SponsorAds: 'Sponsor Ads',
  Templates: 'Templates',
  WelcomeMessage: 'Welcome Message',
  EventSchedule: 'Event Schedule',
  MemberProfiles: 'Member Profiles',
  MemorialTributes: 'Memorial Tributes',
  PhotoGallery: 'Photo Gallery',
  CommitteeReports: 'Committee Reports',
};

// ── API response shape for a single review comment ────────────

export interface ReviewCommentViewItem {
  id: string;
  submissionId: string;
  submissionTitle: string;
  sectionCategory: SectionCategory;
  submissionAuthor: string;
  submissionBookletSection: string | null;
  submissionBody: string | null;
  submissionInMemoryOf: string | null;
  submissionInscription: string | null;
  submissionReviewers: string[];
  commenterName: string;
  text: string;
  isRichText: boolean;
  createdAt: string; // ISO 8601
}

// ── Filter state for the Review Comments view ─────────────────

export interface ReviewCommentsFilterState {
  activeCategory: SectionCategory | null;
  selectedReviewer: string | 'all';
}
